import { FadeUp } from "./Motion";
import { Landmark, Building2, Wallet, ShieldPlus, LineChart, Truck } from "lucide-react";

const audiences = [
  { icon: Landmark, label: "Banks" },
  { icon: Building2, label: "NBFCs" },
  { icon: Wallet, label: "Fintech Lenders" },
  { icon: ShieldPlus, label: "Insurance Companies" },
  { icon: LineChart, label: "Investors" },
  { icon: Truck, label: "Supply-Chain Finance" },
];

export const WhoItsFor = () => {
  return (
    <section id="audience" className="relative py-24 md:py-36 border-t border-ink/10">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <FadeUp>
          <div className="flex items-center gap-6 mb-16">
            <span className="font-mono-cap text-ink/60">§ 06 — Who It&apos;s For</span>
            <span className="hair-divider flex-1" />
          </div>
        </FadeUp>

        <div className="grid grid-cols-12 gap-6 md:gap-10 items-end">
          <div className="col-span-12 lg:col-span-8">
            <FadeUp>
              <h2 className="font-display text-5xl md:text-7xl text-ink leading-[0.98]">
                Built for <br />
                <span className="italic text-teal">financial institutions</span>.
              </h2>
            </FadeUp>
          </div>
          <div className="col-span-12 lg:col-span-4">
            <FadeUp delay={0.15}>
              <p className="font-sans text-ink/70 leading-relaxed">
                A single, comparable signal — designed to slot into existing
                origination, underwriting, and portfolio-monitoring pipelines.
              </p>
            </FadeUp>
          </div>
        </div>

        <div className="mt-16 md:mt-24 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 border-t border-l border-ink/15">
          {audiences.map((a) => {
            const Icon = a.icon;
            return (
              <div
                key={a.label}
                data-testid={`audience-${a.label.toLowerCase().replace(/\s|-/g, "-")}`}
                className="border-r border-b border-ink/15 p-6 md:p-8 flex flex-col gap-6 min-h-[180px] group hover:bg-white transition-colors"
              >
                <div className="w-10 h-10 border border-ink/25 flex items-center justify-center text-ink group-hover:bg-ink group-hover:text-paper transition-colors">
                  <Icon size={18} strokeWidth={1.5} />
                </div>
                <div className="mt-auto">
                  <div className="font-display text-xl md:text-2xl text-ink leading-tight">
                    {a.label}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
